import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-head",
  "use": "icon-head-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol viewBox=\"0 0 64 64\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-head\">\n<rect width=\"64\" height=\"64\" fill=\"#F4F4F5\" />\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M46.3237 43.6899C46.6467 44.689 46.2783 45.7703 45.4477 46.4127C41.7293 49.2887 37.0645 51 31.9999 51C26.9352 51 22.2703 49.2886 18.5518 46.4125C17.7212 45.7701 17.3529 44.6888 17.6759 43.6896C19.4936 38.0667 24.7717 34 30.9998 34H32.9998C39.2279 34 44.5061 38.0669 46.3237 43.6899Z\" fill=\"#BEBEC8\" />\n<circle cx=\"32\" cy=\"25\" r=\"9.5\" fill=\"#BEBEC8\" stroke=\"#F4F4F5\" stroke-width=\"3\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/head.svg
// module id = fxAQ
// module chunks = 45